import BaseApi from "../BaseApi";

export default class EmailBlacklistService {
    static async add(form) {
        try {
            form.tipoDescadastrar = parseInt(form.tipoDescadastrar);
            let res = await BaseApi.post(`v1/email/blacklist/add`, form);
            return res.data;

        } catch (error) {
            return error.response.data;
        }
    }
}